import { BlockType, ComponentSettings } from '@report-content';
import { NewBlockContextType } from './BlockFactory';

export class AbstractBlockFactory<T extends ComponentSettings> {
    public getNewBlock(newBlockContext: NewBlockContextType): BlockType<T> {
        throw 'AbstractBlockFactory Should be extended by Regular Class';
    }
}
